import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const error = location.state?.error;

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await axios.post(`${API_URL}/auth/google`, {
        credential: credentialResponse.credential,
      });

      const token = response.data.session_token;
      if (token) {
        localStorage.setItem('session_token', token);
      }

      setUser(response.data.user);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 'Falha na autenticacao';
      navigate('/', { state: { error: errorMsg }, replace: true });
    }
  };

  const handleGoogleError = () => {
    navigate('/', { state: { error: 'Erro ao autenticar com Google. Tente novamente.' }, replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F7F7F8] to-[#FFFFFF]">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-lg border border-[#E5E5EA] p-8">
          <div className="text-center mb-8">
            <div className="mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_corporate-vault-3/artifacts/r60aqy06_ASICompany.jpg"
                alt="ASI Company"
                className="h-20 mx-auto"
              />
            </div>
            <h1 className="text-3xl font-bold text-[#111111] mb-2">ASI Docs</h1>
            <p className="text-[#6E6E73]">Sistema de Gestao Documental</p>
          </div>

          {error && (
            <div className="mb-6 p-4 bg-[#FFF1F0] border border-[#FFCCC7] rounded-lg">
              <p className="text-[#E11F20] text-sm">{error}</p>
            </div>
          )}

          <div className="flex justify-center" data-testid="login-google-button">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              size="large"
              width="350"
              text="signin_with"
              shape="rectangular"
              logo_alignment="left"
              locale="pt-BR"
            />
          </div>

          <p className="mt-6 text-xs text-center text-[#AEAEB2]">
            Acesso restrito a colaboradores da ASI Company Tecnologia e LinkData
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
